import { render, staticRenderFns } from "./WhatsappContactsList.vue?vue&type=template&id=8eeb2dee"
import script from "./WhatsappContactsList.vue?vue&type=script&lang=js"
export * from "./WhatsappContactsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports